module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag36_1739AT.a8c64306.jpg";